import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import AppNavigator from './AppNavigator'
import FundDepositInvoice from './screens/App/screens/FundDepositInvoice/FundDepositInvoice'
import NotFoundScreen from './screens/App/screens/Not Found/NotFoundScreen'
import SwapInvoice from './screens/App/screens/SwapInvoice/SwapInvoice'
import LoginRedirectScreen from './screens/Login/LoginRedirectScreen'
import LoginScreen from './screens/Login/LoginScreen'
import SignUpScreen from './screens/Login/SignUpScreen'
import SignupCompleteScreen from './screens/Login/SignupCompleteScreen'
import MfaChallengeScreen from './screens/Mfa/MfaChallengeScreen'
import PlatformDashboardScreen from './screens/Public/PlatformDashboard/PlatformDashboardScreen'
import PublicAffiliateStatsScreen from './screens/Public/PublicAffiliateStatsScreen'
import VeliActivationScreen from './screens/Public/VeliActivation/VeliActivationScreen'

export default function App() {
  return (
    <div className="min-h-screen overflow-hidden">
      <Router>
        <Switch>
          <Route path="/app">
            <AppNavigator />
          </Route>
          <Route path="/sign-up">
            <SignUpScreen />
          </Route>
          <Route path="/signup-complete">
            <SignupCompleteScreen />
          </Route>
          <Route path="/mfa/challenge">
            <MfaChallengeScreen />
          </Route>
          <Route path="/login">
            <LoginRedirectScreen />
          </Route>
          <Route exact path="/">
            {/* Warning: LoginScreen (and everything not under AppNavigator) is
          not checked by AppAuthorizationChecker, meaning that the SessionState
          is not type-safe */}
            <LoginScreen />
          </Route>

          <Route path="/otac/swap-invoice">
            <SwapInvoice />
          </Route>

          <Route path="/otac/fund-deposit-invoice">
            <FundDepositInvoice />
          </Route>

          <Route path="/affiliate/stats">
            <PublicAffiliateStatsScreen />
          </Route>

          <Route path="/dashboard">
            <PlatformDashboardScreen />
          </Route>

          <Route path="/veli-onboarding/:veliUserId">
            <VeliActivationScreen />
          </Route>

          <Route path="*">
            <NotFoundScreen />
          </Route>
        </Switch>
      </Router>
    </div>
  )
}
